export type BuildUrlInput = {
    redirectUrl: string;
    mpvId: string;
    workId?: string;
    multistep?: string;
    requestType?: string;
};

export function buildRedirectUrl({
    redirectUrl,
    mpvId,
    workId,
    multistep,
    requestType = 'Standard',
}: BuildUrlInput) {
    const url = new URL(redirectUrl);

    url.searchParams.set('mpvId', mpvId);
    url.searchParams.set('requestType', requestType);

    if (workId) {
        url.searchParams.set('workId', workId);
    }

    if (multistep) {
        url.searchParams.set('multistep', multistep);
    }

    return url.toString();
}
